import React from 'react'
import { zoneFromScore, zoneToScore } from '../api/map'

interface ExperienceButtonsProps {
  /** 현재 점수(0~10). 0 미만이면 미선택 */
  value: number
  /** 선택 시 해당 존의 대표 점수로 변경 */
  onChange: (score: number) => void
  disabled?: boolean
  addClassName?: string
}

// 존 인덱스 ↔ 라벨 (백엔드 ZONE_COUNT=4와 1:1)
const ZONES: { zone: number; label: string }[] = [
  { zone: 0, label: '다신 안가' },
  { zone: 1, label: '아쉬워' },
  { zone: 2, label: '좋아' },
  { zone: 3, label: '완벽해' },
]

/**
 * 이용 경험 선택 — 슬라이더 대신 4개 버튼(다신안가/아쉬워/좋아/인생맛집).
 * 짝수 스케일(중립 없음)이라 가운데 쏠림이 없고, 선택값은 존의 대표 점수.
 * 정밀 점수는 이후 같은 존 내 비교·순위 플로우에서 결정된다.
 */
const ExperienceButtons: React.FC<ExperienceButtonsProps> = ({
  value,
  onChange,
  disabled = false,
  addClassName,
}) => {
  const selectedZone = value < 0 ? null : zoneFromScore(value)

  return (
    <div
      className={`w-full flex justify-between items-start ${addClassName ?? ''}`}
    >
      {ZONES.map(({ zone, label }) => {
        const selected = selectedZone === zone
        return (
          <button
            key={zone}
            type="button"
            disabled={disabled}
            onClick={() => onChange(zoneToScore(zone))}
            className={`
              w-64px flex flex-col items-center gap-12px select-none
              ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
            `}
          >
            <span className="h-49px flex items-center justify-center">
              <span
                className={`
                  rounded-full transition-all duration-150
                  ${
                    selected
                      ? 'w-49px h-49px bg-brown-80%-main'
                      : 'w-45px h-45px bg-divider-divider-1'
                  }
                `}
              />
            </span>
            <span
              className={`
                font-pretendard font-700 text-14px leading-none whitespace-nowrap
                ${selected ? 'text-brown-80%-main' : 'text-textColorText3'}
              `}
            >
              {label}
            </span>
          </button>
        )
      })}
    </div>
  )
}

export default ExperienceButtons
